import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "Actions";
import { CreditCards } from "Utils/SvgIcons";
import CreditCardLineItem from "./creditCards/CreditCardLineItem";
import LoadingSpinner from "Utils/LoadingSpinner";

// Fetch profile info from Redux customer, then display it.

class ProfilePaymentMethods extends React.Component {
  componentDidMount() {
    const { fetchProfile, location } = this.props; // Redux
    fetchProfile(location.id);
  }

  render() {
    const { customer, loading, location } = this.props;
    if (loading) {
      return <LoadingSpinner />;
    }
    return (
      <section className="payments">
        <h4>Payment Methods</h4>
        <CreditCards />
        <div>
          <Link className="btn" to="/profile/paymentMethods/new">
            Add A New Card
          </Link>
          {customer.creditCards && (
            <ul className="itemList">
              {customer.creditCards.filter(card => card.paymentProcessor === location.paymentProcessor).map(creditCard => (
                <CreditCardLineItem
                  creditCard={creditCard}
                  key={creditCard.id}
                  locationId={location.id}
                />
              ))}
            </ul>
          )}
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => {
  const { location } = state.locations;
  const { customer, errors, loading } = state.customer;
  return { location, customer, errors, loading };
};

export default connect(mapStateToProps, actions)(ProfilePaymentMethods);
